import {
    DRIVER_PACKAGE_SUMMARY,
    DRIVER_PACKAGE_SUMMARY_ERROR,
    DRIVER_PACKAGE_SUMMARY_SUCCESS,
    REFRESH_BUTTON_SUCCESS_MESSAGE,
    REFRESH_BUTTON_ERROR_MESSAGE,
    RESPONSE_TYPE, DRIVER_PACKAGE_SUMMARY_CACHE_KEY, FETCH_FROM_CACHE, FILTER_DATA, TOGGLE_REFRESH_BUTTON

} from "../constants/DriverPackageSummaryConstants";
import {driverPackageSummaryNetwork} from "../network/DriverPackageSummaryNetwork";
import {getDataWithExpiry, setDataWithExpiry} from "../../util/CacheManager";

export const DriverPackageSummaryReducer = (state, action) => {
    switch (action.type) {
        case DRIVER_PACKAGE_SUMMARY:
            const  {dispatcher} = action.data;
            driverPackageSummaryNetwork(dispatcher);
            return {...state, loading: true, success: false};
        case DRIVER_PACKAGE_SUMMARY_SUCCESS:
            setDataWithExpiry(DRIVER_PACKAGE_SUMMARY_CACHE_KEY, action.data);
            return {...state,
                stationCount: action.data[1],
                driversCount: action.data[0],
                filteredDriversCount: action.data[0],
                loading: false,
                success: true,
                refreshButtonAlertType: RESPONSE_TYPE.SUCCESS,
                refreshButtonAlertMessage:REFRESH_BUTTON_SUCCESS_MESSAGE};
        case DRIVER_PACKAGE_SUMMARY_ERROR:
            return {...state,
                stationCount: [],
                driversCount: [],
                filteredDriversCount: [],
                loading: false,
                success: false,
                refreshButtonAlertType: RESPONSE_TYPE.ERROR,
                refreshButtonAlertMessage: REFRESH_BUTTON_ERROR_MESSAGE};
        case FILTER_DATA:
            return {
                ...state, filteredDriversCount: state.driversCount.filter(driver => {
                    return driver.driverName.toLowerCase().startsWith(action.data.prefix.toLowerCase())
                })
            };
        case TOGGLE_REFRESH_BUTTON:
            return { ...state, enableRefreshButton: !state.enableRefreshButton}
        case FETCH_FROM_CACHE:
            const cachedData = getDataWithExpiry(DRIVER_PACKAGE_SUMMARY_CACHE_KEY);
            if (cachedData.cachedData!= null) {
                return {
                    ...state,
                    stationCount: cachedData.cachedData[1],
                    driversCount: cachedData.cachedData[0]
                }
            }
            return {...state}
        default:
            return state
    }
};


// WEBPACK FOOTER //
// ./src/components/driverPackageSummary/reducer/DriverPackageSummaryReducer.js